<template>
    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-card-title
                class="text-h5 aviso"
                style="
                    justify-content: center;
                    background: #1d2735;
                    color: white;
                "
            >
                Email
            </v-card-title>
            <v-card-text style="text-align: center">
                ¿Desea enviar la incidencia a el comercial encargado de este
                presupuesto?
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>

                <v-btn color="error" large @click="dialog = false"
                    >Cancelar</v-btn
                >
                <v-btn color="success" large @click="sendEmail()"
                    >Confirmar</v-btn
                >
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: ["value", "presupuesto"],
    data() {
        return {
            dialog: false,
        };
    },
    created() {
        if (this.value != null) {
            this.dialog = this.value;
        }
    },
    methods: {
        async sendEmail() {
            try {
                await axios.post(
                    `api/presupuesto/${this.presupuesto.id}/incidencia-mail`
                );
                this.dialog = false;
            } catch (ex) {
                throw ex;
            }
        },
    },
    watch: {
        dialog(val) {
            this.$emit("input", val);
        },
        value(val) {
            this.dialog = val;
        },
    },
};
</script>
